import {
  createPluginFactory,
  isText,
  getBlockAbove,
  removeNodes,
} from '@udecode/plate-common';

export const KEY_ENHANCED_NORMALIZER = 'enhanced_normalizer';

const withEnhancedNormalizer = (editor) => {
  const { normalizeNode } = editor;
  editor.normalizeNode = ([node, path]) => {
    // Checks if there's a text node without a parent. This causes the editor to crash.
    if (isText(node) && !getBlockAbove(editor, { at: path })) {
      // Remove the text node.
      removeNodes(editor, { at: path });
    }

    normalizeNode([node, path]);
  };

  return editor;
};

/**
 * Enables support for apply additional normalization for edge cases that break the editor.
 */
export const createEnhancedNormalizerPlugin = createPluginFactory({
  key: KEY_ENHANCED_NORMALIZER,
  withOverrides: withEnhancedNormalizer,
});

